<template>
  <div class="comp-ly-advanced-filter">
    <!--系统及自定义检索 -->
    <template v-if="dataPermission === 0 || entity == 101">
      <dropdown-filter ref="dropdownFilterRef" v-if="!highConditionsLoading" :entity="entity" :viewId="viewId" :highList="highConditionsList" @cb="handelHighFilter" />
      <div v-else class="title-split-skeleton-select title-split-skeleton-heigh"></div>
    </template>
    <!-- 根据字段筛选 -->
    <field-filter v-if="fieldList.length" :fieldColumns="fieldList" @cb="fieldCondition" :entityId="entity"></field-filter>
    <div v-else class="title-split-skeleton-select"></div>
    <jw-button v-if="viewClass != '30'" class="list-container-btn" type="secondary" @click="openColSelect" size="small">
      <template #icon>
        <qfei-icon-column-setting-outlined />
      </template>
      <template #default>列设置</template>
    </jw-button>
    <!-- 高级筛选 -->
    <jw-trigger v-if="!useFilterList.conditionsListLoading" trigger="click" unmount-on-close position="bl" :popup-visible="data.popupVisible" :show-arrow="true" :popup-offset="4" arrow-class="arrow-filter" popup-container=".comp-ly-advanced-filter">
      <jw-button size="small" class="list-container-btn" :type="heightConditionsNum > 0 ? 'outline' : 'secondary'" :class="heightConditionsNum > 0 ? 'filter-btn' : 'default-btn'" @click="handleFilterClick">
        <template #icon>
          <qfei-icon-filter-outlined />
        </template>
        <jw-space size="mini">
          <span v-show="heightConditionsNum > 0">{{ heightConditionsNum }}</span>
          <span> {{ filterText }}</span>
        </jw-space>
      </jw-button>

      <template #content>
        <fh-custom-search-ultra ref="customFieldConditionRef" :entity="entity" :conditions="filterConditions?.children" :isCascadingMultiple="false" :showDefaultCondition="true" @cb="getConditions" searchType="highFilter" @clearAll="clearAllCondition" :maxHeight="500" @submit="searchSubmit" :headerIsBold="true" :width="720" :needSplitDateRange="true">
          <template #btn>
            <jw-button v-if="!isDetailTable && entity != 101" type="text" @click="saveCondition">保存为常用检索</jw-button>
          </template>
        </fh-custom-search-ultra>
      </template>
    </jw-trigger>
    <div v-else class="title-split-skeleton-select title-split-skeleton-field"></div>
    <!-- 分组按钮 -->
    <template v-if="viewClass != '30'">
      <list-group v-if="!groupSortLoading" :entity="entity" :viewId="viewId" :fieldGroups="groupInfo" @cbGroup="hasGroup" />
      <div v-else class="title-split-skeleton-select title-split-skeleton-field"></div>
    </template>
    <template v-else>
      <!-- 看板视图走自己的逻辑处理 -->
      <template v-if="hasObjectPermission">
        <jw-button size="small" class="list-container-btn advanced-text-color" :class="{ 'is-disabled': componentGroupInfo?.fieldStatus == '2' }" @click="openGroupFieldModal">
          <template #icon>
            <qfei-icon-grouping-outlined />
          </template>
          <jw-space size="mini">
            <span> {{ $t('分组字段') }}：</span>
            <span :class="{ 'default-text-color': componentGroupInfo?.fieldStatus != '2' }">
              {{ componentGroupInfo?.fieldStatus == '2' ? componentGroupInfo?.fieldName + '（已停用）' : componentGroupInfo?.fieldName }}
            </span>
          </jw-space>
        </jw-button>
        <jw-button size="small" class="list-container-btn advanced-text-color" @click="openDashboardFieldSettingModal">
          <template #icon>
            <qfei-icon-management-outlined />
          </template>
          <jw-space size="mini">
            <span>{{ $t('卡片配置') }}</span>
          </jw-space>
        </jw-button>
      </template>
    </template>
    <!-- 列表排序 -->
    <list-sort v-if="!groupSortLoading" :viewId="viewId" :entity="entity" :fieldList="useTableInfo?.columnFieldList" @cbSort="sortChange"></list-sort>
    <div v-else class="title-split-skeleton-select title-split-skeleton-field"></div>
  </div>
  <teleport to="body">
    <common-search :entity="entity" ref="commonSearchRef" @cb="getCommonList"></common-search>
  </teleport>

  <div v-if="showOverlay" class="overlay" @click.stop="hideLay"></div>
  <dashboard-group-field @cb="editGroupField" ref="dashboardRef" />
</template>

<script setup>
import { reactive, ref, watch, nextTick, onMounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import useMainTable from '@/hooks/main-table';
import { useFilterListStore, useMainTableStore, useUserStore } from '@/store';
import { Message } from '@arco-design/web-vue';
import DashboardGroupField from '@/components/dashboard-group-field/dashboard-group-field.vue';
import ListGroup from './components/list-group/list-group.vue';
import listSort from './components/list-sort/list-sort.vue';
import { QfeiIconFilterOutlined } from '@qfei-design/icons-vue';
import { layoutService } from '@/api';
const { t } = useI18n();
console.log('1-开始创建组件-setup');
const { userInfo } = useUserStore(); //用户信息
const emits = defineEmits(['cb', 'cbGroup', 'cbSort']);
const useFilterList = useFilterListStore(); // 筛选条件store
// groupFieldList,
const { highConditionsLoading, highConditionsList, getConditionList, getGroupAndSortInfo, groupSortLoading, setGroupFieldsInfo } = useMainTable();

const props = defineProps({
  viewId: {
    type: [String, Number],
    default: ''
  },
  dataPermission: {
    type: [String, Number],
    default: 0
  },
  entity: {
    type: [String, Number],
    default: ''
  },
  universalButtonParams: {
    type: Object,
    default: () => {}
  },
  dropdownFieldList: {
    type: Array,
    default: () => []
  },
  dropdownLoading: {
    type: Boolean,
    default: false // 下拉筛选字段loading
  },
  // commonList: {
  //   type: Array,
  //   default: () => []
  // },
  groupInfo: {
    // 分组信息
    type: Array,
    default: () => []
  },
  viewClass: {
    type: [String, Number],
    default: '10'
  },
  lyListLayout: {
    type: Object,
    default: () => null
  }
});
const hasObjectPermission = computed(() => {
  return userInfo?.roles?.indexOf(props.entity >= 200 ? 'object:custom' : 'object:system') !== -1;
});
const dashboardRef = ref();
const componentGroupInfo = ref({});
const openGroupFieldModal = () => {
  dashboardRef.value.open(props.entity, props.groupInfo?.[0]?.fieldKey);
};
const editGroupField = async ({ fieldInfo }) => {
  componentGroupInfo.value.fieldName = fieldInfo?.fieldName;
  componentGroupInfo.value.fieldKey = fieldInfo?.fieldKey;
  componentGroupInfo.value.fieldStatus = 1;
  try {
    const params = {
      entity: props.entity,
      viewId: props.viewId,
      fieldGroups: [
        {
          fieldExt: fieldInfo?.fieldExt,
          fieldKey: fieldInfo?.fieldKey,
          fieldName: fieldInfo?.fieldName,
          fieldSort: true,
          fieldStatus: 1,
          fieldType: fieldInfo?.fieldType,
          subProperty: ''
        }
      ]
    };
    const res = await layoutService.saveOrUpdate(params);
    if (!res?.error) {
      emits('cbGroup', params.fieldGroups);
    } else {
      Message.error(res?.error?.msg || t('操作失败'));
    }
  } catch (e) {
    console.log(e);
  }
};

const openDashboardFieldSettingModal = () => {
  lyListLayoutRef.value?.openDashboardFieldSettingModal?.();
};

const showCmp = ref(false);
const data = reactive({
  highList: [],
  sceneType: 0,
  sceneId: 0,
  popupVisible: false
});
// const conditionLoading = ref(false);
const lyListLayoutRef = computed(() => props.lyListLayout);
const openColSelect = () => {
  lyListLayoutRef.value?.openColSelect();
};
const showOverlay = ref(false);
const dropdownFilterRef = ref();
// 高级筛选触发回调
const handelHighFilter = async (params) => {
  data.sceneId = params.sceneId;
  data.sceneType = params.sceneType;
  if (params.type === 'refresh') {
    await getCommonList();
  } else if (params.type === 'delete') {
    // 常用检索的删除操作
    await getCommonList();
    const defaultItem = highConditionsList.value?.find((v) => v.isDefault);
    data.sceneId = defaultItem.type === 0 ? defaultItem.scope : defaultItem.id;
    data.sceneType = defaultItem.type;
    if (params?.isCurrent) {
      dropdownFilterRef.value.updateSceneId({ type: 0, id: data.sceneId });
    }
    emits('cb', { type: false, sceneId: data.sceneId, sceneType: data.sceneType, conditions: filterConditions.value.children, searchConditions: searchParams.value });
  } else {
    if (params.type == 1) {
      //type===1并且有sceneId 代表编辑的是当前选中项
      if (params?.sceneId) {
        await getCommonList();
      }
      filterConditions.value.children = [];
      emits('cb', { type: true, sceneType: 1, sceneId: data.sceneId, conditions: [], searchConditions: searchParams.value });
    } else {
      // 初始化的一些操作
      if (showCmp.value) {
        emits('cb', { type: false, sceneType: data.sceneType, sceneId: data.sceneId, conditions: filterConditions.value.children, searchConditions: searchParams.value });
      }
    }
  }
};

const validateData = (data) => {
  return data.every((group) => {
    return group.children.every((child) => {
      if (!child.field) {
        return false;
      }
      if (child.operation === 'null' || child.operation === 'not_null') {
        return true;
      } else {
        if (child.value || child.value === 0) {
          return true;
        } else {
          return false;
        }
      }
    });
  });
};

// 公共条件组件触发回调
const filterText = ref(t('筛选'));
const filterConditions = ref({ value: null });
const commonSearchRef = ref();
const getConditions = async (record) => {
  // 处理需要验证条件的情况
  if (record.type === 1 || record.type === 2) {
    if (!validateData(record.conditions)) {
      Message.warning('请完善筛选条件');
      return;
    }
    filterConditions.value.children = record.conditions;
    hideLay(1);
    // 触发回调事件
    emits('cb', {
      type: true,
      sceneType: data.sceneType,
      sceneId: data.sceneId,
      conditions: record.conditions,
      searchConditions: searchParams.value
    });

    // 类型2特有的操作
    if (record.type === 2) {
      commonSearchRef.value.openDialog({
        type: 3,
        conditionList: record.conditions,
        highList: highConditionsList.value
      });
    }
    return;
  }
  // 默认情况：获取自定义字段条件
  filterConditions.value.children = await customFieldConditionRef.value.getAllConditions(false);
};

//清空所有
const clearAllCondition = () => {
  filterConditions.value = {};
  filterConditions.value.children = [];
};
// 高级筛选提交
const searchSubmit = async (record) => {
  console.log('conditionsList-4', record);
  if (record) {
    const data = {
      type: 1,
      conditions: record
    };
    getConditions(data);
  }
};
//是否有分组
const hasGroup = (fieldGroups) => {
  setGroupFieldsInfo(fieldGroups);
  emits('cbGroup', fieldGroups);
};
// 排序发生变化
const sortChange = (v) => {
  console.log('sortChange-advanced-filter', v);
  emits('cbSort', v);
};
// 保存为常用
const saveCondition = async () => {
  const newData = await customFieldConditionRef.value.getAllConditions();
  if (newData) {
    const data = {
      type: 2,
      conditions: newData
    };
    getConditions(data);
  }
};

const customFieldConditionRef = ref();
// 点击筛选按钮
const handleFilterClick = () => {
  data.popupVisible = true;
  showOverlay.value = true;
  filterConditions.value.children = JSON.parse(JSON.stringify(useFilterList?.conditionsList));
};

const hideLay = async () => {
  filterConditions.value.children = await customFieldConditionRef.value.getAllConditions(false);
  nextTick(() => {
    showOverlay.value = false;
    data.popupVisible = false;
  });
};
// 获取检索筛选列表
const getCommonList = async () => {
  await getConditionList({ entity: props.entity });
};
const searchParams = ref([]);
// 根据字段筛选
const fieldCondition = (item) => {
  searchParams.value = [{ field: '', fieldType: '', isGroup: true, operation: 'and', value: null, children: item.params ? [item.params] : [] }];
  emits('cb', { type: false, sceneType: data.sceneType, sceneId: data.sceneId, conditions: filterConditions.value.children, searchFields: item.params }, 'fieldSearch');
};

// 表头筛选改变时会改变store中的数据，所以要实时监听改变筛选条件
watch(
  () => useFilterList?.conditionsList,
  (v) => {
    filterConditions.value.children = JSON.parse(JSON.stringify(v));
  },
  {
    deep: true,
    immediate: true
  }
);
const checkData = (data) => {
  return data?.some((group) => {
    return group?.children?.some((child) => {
      if ((child.operation === 'null' || child.operation === 'not_null') && child.field) {
        return true;
      } else if (child.operation !== 'null' && child.operation !== 'not_null' && child.field && (child.value || child.value === 0)) {
        return true;
      }
      return false;
    });
  });
};

const isDetailTable = ref(true);
watch(
  () => filterConditions.value?.children,
  (v) => {
    if (v?.length && checkData(v)) {
      isDetailTable.value = false;
    } else {
      isDetailTable.value = true;
    }
  },
  {
    deep: true,
    immediate: true
  }
);

const useTableInfo = useMainTableStore();
const fieldList = ref([]);
const heightConditionsNum = computed(() => props.universalButtonParams.filterParams?.conditions?.length || useFilterList.conditionsList?.length || 0);
onMounted(async () => {
  await Promise.all([getGroupAndSortInfo({ entity: props.entity, viewId: props.viewId }), getCommonList(), useFilterList.getConditionsList({ entity: props.entity })]);
  console.log(useTableInfo.columnFieldList);
  fieldList.value = useTableInfo.columnFieldList;
  // 如果返回的权限为0则隐藏高级筛选 scope默认值=0      0展示 1 不展示
  if (props.dataPermission !== 0 && props.entity != 101) {
    data.sceneType = 0;
    data.sceneId = 0;
  }
  // 非线索池执行  线索池 初始化再 handelHighFilter 方法里执行
  if (props.entity != 101) {
    emits('cb', { type: false, sceneType: data.sceneType, sceneId: data.sceneId, conditions: filterConditions.value.children, searchConditions: searchParams.value, groupFieldList: props.groupInfo });
  }
  showCmp.value = true;
  componentGroupInfo.value = props.groupInfo?.[0] || {};
});
</script>
<style scoped lang="less">
@import './ly-advanced-filter.less';
</style>
